const state = {
  textBook: localStorage.getItem('textBook') ? JSON.parse(localStorage.getItem('textBook')) : '',
  textBookMaterial: localStorage.getItem('textBookMaterial')
    ? JSON.parse(localStorage.getItem('textBookMaterial'))
    : '',
  textBookUnit: localStorage.getItem('textBookUnit') ? JSON.parse(localStorage.getItem('textBookUnit')) : '',
  // 课文列表（所有分组下的课文平铺，用于课文切换）
  textBookUnitList: localStorage.getItem('textBookUnitList') ? JSON.parse(localStorage.getItem('textBookUnitList')) : []
}

const mutations = {
  // reset all
  SMART_TEACHING_SYSTEM_RESET_ALL(state, data) {
    const remove = ['textBook', 'textBookUnit']
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },
  // textBook
  SMART_TEACHING_SYSTEM_TEXT_BOOK(state, data) {
    state.textBook = data
    data === '' ? localStorage.removeItem('textBook') : localStorage.setItem('textBook', JSON.stringify(data))
  },
  // textBookMaterial
  SMART_TEACHING_SYSTEM_TEXT_BOOK_MATERIAL(state, data) {
    state.textBookMaterial = data
    data === ''
      ? localStorage.removeItem('textBookMaterial')
      : localStorage.setItem('textBookMaterial', JSON.stringify(data))
  },
  // textBookUnit
  SMART_TEACHING_SYSTEM_TEXT_BOOK_UNIT(state, data) {
    state.textBookUnit = data
    data === '' ? localStorage.removeItem('textBookUnit') : localStorage.setItem('textBookUnit', JSON.stringify(data))
  },
  // textBookUnitList
  SMART_TEACHING_SYSTEM_TEXT_BOOK_UNIT_LIST(state, data) {
    state.textBookUnitList = data
    if (!data || !data.length) {
      localStorage.removeItem('textBookUnitList')
    } else {
      localStorage.setItem('textBookUnitList', JSON.stringify(data))
    }
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_RESET_ALL', '')
      resolve()
    })
  },
  // 设置选中课文听读书籍
  setTextBook({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_TEXT_BOOK', data)
      resolve(data)
    })
  },
  // 设置选中课文听读教材版本
  setTextBookMaterial({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_TEXT_BOOK_MATERIAL', data)
      resolve(data)
    })
  },
  // 设置选中课文听读单元
  setTextBookUnit({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_TEXT_BOOK_UNIT', data)
      resolve(data)
    })
  },
  // 设置课文列表（所有分组下的课文平铺）
  setTextBookUnitList({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_TEXT_BOOK_UNIT_LIST', data)
      resolve(data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
